import React from 'react';
import { IColumn } from '@fluentui/react';
import { Link } from 'react-router-dom';
import momentUtc from '../../../utils/DateFormatter';
import StatDateFormats from '../../../utils/types/DateFormats';

interface IProcessData {
  processType: string;
  processTypeId: number;
  onTrack: number;
  late: number;
}

const getComplianceSnapshotProcessesColumns = (
  companyCode?: string,
  canViewProcesses = true,
): IColumn[] => {
  // Create base query parameters that are constant for all records
  const baseQueryParams = new URLSearchParams();
  if (companyCode) {
    baseQueryParams.append('companyCodes', companyCode);
  }
  baseQueryParams.append('processStatuses', 'ACTIVE');

  // Helper function to create filter URL with filing due date parameters
  const createFilterUrl = (item: IProcessData, filterType: 'onTrack' | 'late'): string => {
    const queryParams = new URLSearchParams(baseQueryParams);
    if (item.processTypeId) {
      queryParams.append('processTypeIds', item.processTypeId.toString());
    }

    const today = new Date();
    const yesterday = new Date();
    yesterday.setUTCDate(today.getUTCDate() - 1);

    if (filterType === 'onTrack') {
      // On-Track: filingDueFromDate = today, filingDueToDate = null
      queryParams.append('filingDueFromDate', momentUtc(today, StatDateFormats.Default));
    } else if (filterType === 'late') {
      // Late: filingDueFromDate = null, filingDueToDate = yesterday
      queryParams.append('filingDueToDate', momentUtc(yesterday, StatDateFormats.Default));
    }

    return `/processes?${queryParams.toString()}`;
  };

  return [
    {
      key: 'processType',
      name: 'Process Type',
      fieldName: 'processType',
      minWidth: 250,
      maxWidth: 400,
      isResizable: true,
    },
    {
      key: 'onTrack',
      name: 'On Track',
      fieldName: 'onTrack',
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: IProcessData) => {
        if (item.onTrack === 0) {
          return <span style={{ color: 'inherit' }}>0</span>;
        }

        if (!canViewProcesses) {
          return <span style={{ color: 'inherit' }}>{item.onTrack}</span>;
        }

        const url = createFilterUrl(item, 'onTrack');

        return <Link to={url}>{item.onTrack}</Link>;
      },
    },
    {
      key: 'late',
      name: 'Late',
      fieldName: 'late',
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: IProcessData) => {
        if (item.late === 0) {
          return <span style={{ color: 'inherit' }}>0</span>;
        }

        if (!canViewProcesses) {
          return <span style={{ color: 'inherit' }}>{item.late}</span>;
        }

        const url = createFilterUrl(item, 'late');

        return <Link to={url}>{item.late}</Link>;
      },
    },
  ];
};

export default getComplianceSnapshotProcessesColumns;
export type { IProcessData };
